var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIc20ArrowLeft1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M18 10a1 1 0 0 1-1 1H5.415l2.292 2.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.32.083l-.094-.083-4-4-.042-.044-.055-.068-.071-.11-.054-.114-.035-.105-.03-.149L2 10l.003-.075.017-.126.03-.111.044-.111.052-.098.067-.096c.025-.031.051-.062.08-.09l4-4a1 1 0 0 1 1.497 1.32l-.083.094L5.415 9H17a1 1 0 0 1 1 1Z",
  clipRule: "evenodd"
})));
export default SvgIc20ArrowLeft1;